const Route = (props) => null;
Route.displayName = 'Route';

export { Route };
